import React from 'react'
import PropTypes from 'prop-types'
import {Link} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Link as RouteLink} from 'react-router-dom'
import usePdTagManager from '../../../../hooks/use-pd-tag-manager'
export const ScrollingPromoBarItem = ({
    linkText,
    linkUrl,
    linkAriaLabel,
    linkColor = 'black',
    linkFontFamily = 'cormorant',
    analyticsProps
}) => {
    const route = linkUrl?.split('.com')?.[1]
    const isExternalDomain = linkUrl?.indexOf('http') !== -1
    const linkProps = isExternalDomain ? {href: linkUrl} : {as: RouteLink, to: route || linkUrl}
    const pdTagManager = usePdTagManager()
    return (
        <Link
            {...linkProps}
            color={linkColor}
            aria-label={linkAriaLabel}
            fontFamily={linkFontFamily}
            display="flex"
            alignItems="center"
            paddingX={{base: '15px', 'xl-large': '45px'}}
            fontSize={{base: '14px', 'xl-large': '26px'}}
            letterSpacing={{base: '1.4px', 'xl-large': '3px'}}
            height={{base: '40px', 'xl-large': '60px'}}
            whiteSpace="nowrap"
            lineHeight="normal"
            fontWeight="400"
            _hover={{
                textDecoration: 'none'
            }}
            onClick={() => {
                pdTagManager.selectComponent({
                    componentId: analyticsProps?.componentType || '',
                    componentName: analyticsProps?.componentName || '',
                    titleName: linkText,
                    titlePosition: analyticsProps?.index % 4,
                    linkUrl: linkUrl
                })
            }}
        >
            {linkText}
        </Link>
    )
}

ScrollingPromoBarItem.propTypes = {
    linkText: PropTypes.string.isRequired,
    linkUrl: PropTypes.string.isRequired,
    linkAriaLabel: PropTypes.string,
    linkColor: PropTypes.string,
    linkFontFamily: PropTypes.string,
    analyticsProps: PropTypes.shape({
        componentType: PropTypes.string,
        componentName: PropTypes.string,
        index: PropTypes.number
    })
}

export default ScrollingPromoBarItem
